var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "50%",
    x2: "50%",
    y1: "100.004%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "36.91%",
    x2: "64.017%",
    y1: "103.528%",
    y2: "4.651%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: "36.989%",
    x2: "64.095%",
    y1: "102.99%",
    y2: "4.113%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__f",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__a",
    cx: 119,
    cy: 119,
    r: 119
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6 43)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.5,
    cy: 30.583,
    fill: "url(#prefix__c)",
    opacity: 0.8,
    rx: 39.355,
    ry: 30.356,
    transform: "translate(77 4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 35.5,
    fill: "#47BAE8",
    rx: 38.5,
    ry: 29.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M83.145 37.397c0-16.563 17.287-29.99 38.613-29.99 6.621-.037 13.176 1.32 19.242 3.981C134.213 6.793 125.334 4 115.616 4 94.29 4 77 17.428 77 33.991 77 45.113 84.795 54.821 96.377 60c-8.109-5.499-13.232-13.584-13.232-22.603z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47BAE8",
    d: "M116.5 46L159.25 120.501 202 195 116.5 195 31 195 73.75 120.501z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M34.608 31.97l3.316-9.812c2.341-7.015-.192-14.732-6.24-19.01l.027-.016c-1.304-.916-2.735-1.638-4.247-2.145L27.418.97l-.05-.016C25.9.46 24.368.173 22.821.102c-.548-.028-1.096-.028-1.644 0-.95.05-1.893.18-2.821.389-.27.059-.538.126-.783.198-.245.073-.519.15-.774.233-.511.17-1.014.36-1.507.577-.247.107-.492.22-.731.34-.724.357-1.42.766-2.085 1.223-.223.153-.44.311-.656.472-2.659 2.016-4.649 4.781-5.713 7.938L.896 26.93c-.82 2.424-1.067 5.005-.721 7.54.054.39.12.775.199 1.159.078.383.175.762.269 1.137.072.25.148.499.231.745.124.368.27.735.406 1.094.1.24.205.478.315.714.218.47.46.928.72 1.375.262.448.539.885.85 1.309.227.316.466.628.713.928.334.402.684.804 1.055 1.161 1.606 1.615 3.529 2.883 5.648 3.725l.092.037c.113-.201.24-.395.376-.582.807-1.102 2.211-1.877 3.548-1.587.097.021.193.05.29.08.678.239 1.345.665 1.999.874.48.216 1.033.21 1.509-.018 1.307-.695.823-2.886 1.944-3.846.052-.044.107-.085.164-.123-.016-.02-.03-.04-.043-.062.866-.536 2.066-.18 3.064.167 1.076.378 2.48.632 3.227-.244.506-.601.468-1.516.95-2.146.56-.724 1.614-.804 2.525-.675l.046.013c1.748.719 3.658-.475 3.524-2.354-.16-2.508.632-4.87.812-5.382z",
    opacity: 0.3,
    transform: "translate(91 120)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M102.743 165.45c.798-1.05 2.167-1.783 3.478-1.497 1.312.285 2.555 1.483 3.721.883 1.596-.818.465-3.825 3.055-4.048.54-.034 1.08.056 1.576.263 1.093.427 2.804.91 3.645-.053.495-.566.46-1.429.932-2.016.546-.681 1.587-.768 2.475-.637l.044.013c1.713.68 3.587-.448 3.453-2.22-.172-2.36.61-4.583.779-5.065l3.246-9.257c2.874-8.26-1.747-17.198-10.341-20-8.61-2.753-17.92 1.681-20.838 9.926l-5.118 14.557c-2.76 7.948 1.41 16.584 9.514 19.701.115-.19.242-.374.38-.55z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 129.5,
    r: 1.5,
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 133.5,
    r: 1.5,
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.811,
    cy: 138.03,
    fill: "#E0E0E0",
    rx: 2.625,
    ry: 1.751,
    transform: "rotate(-71.4 111.811 138.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 130.5,
    r: 2.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 125.5,
    r: 1.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(96 14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M34.608 31.97l3.316-9.812c2.341-7.015-.192-14.732-6.24-19.01l.027-.016c-1.304-.916-2.735-1.638-4.247-2.145L27.418.97l-.05-.016C25.9.46 24.368.173 22.821.102c-.548-.028-1.096-.028-1.644 0-.95.05-1.893.18-2.821.389-.27.059-.538.126-.783.198-.245.073-.519.15-.774.233-.511.17-1.014.36-1.507.577-.247.107-.492.22-.731.34-.724.357-1.42.766-2.085 1.223-.223.153-.44.311-.656.472-2.659 2.016-4.649 4.781-5.713 7.938L.896 26.93c-.82 2.424-1.067 5.005-.721 7.54.054.39.12.775.199 1.159.078.383.175.762.269 1.137.072.25.148.499.231.745.124.368.27.735.406 1.094.1.24.205.478.315.714.218.47.46.928.72 1.375.262.448.539.885.85 1.309.227.316.466.628.713.928.334.402.684.79 1.055 1.161 1.606 1.615 3.529 2.883 5.648 3.725l.092.037c.113-.201.24-.395.376-.582.807-1.102 2.211-1.877 3.548-1.587.097.021.193.05.29.08.678.239 1.345.665 1.999.874.48.216 1.033.21 1.509-.018 1.307-.695.823-2.886 1.944-3.846.052-.044.107-.085.164-.123-.016-.02-.03-.04-.043-.062.866-.536 2.066-.18 3.064.167 1.076.378 2.48.632 3.227-.244.506-.601.468-1.516.95-2.146.56-.724 1.614-.804 2.525-.675h.046c1.748.718 3.658-.475 3.524-2.355-.16-2.494.632-4.856.812-5.368z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.353 46.447c.785-1.072 2.133-1.823 3.424-1.53 1.291.291 2.515 1.517 3.663.903 1.571-.837.458-3.913 3.007-4.14.532-.035 1.064.056 1.552.268 1.076.437 2.76.93 3.588-.054.487-.58.452-1.461.917-2.062.538-.697 1.563-.786 2.437-.652l.043.014c1.687.694 3.532-.459 3.4-2.272-.17-2.413.6-4.687.767-5.18l3.195-9.469c2.83-8.45-1.72-17.592-10.18-20.458C18.69-1.002 9.525 3.535 6.652 11.968l-5.038 14.89C-1.104 34.989 3 43.823 10.979 47.012c.114-.195.238-.383.374-.564z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.308,
    cy: 10.48,
    fill: "#000",
    opacity: 0.2,
    rx: 1.751,
    ry: 1.746
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.265,
    cy: 13.818,
    fill: "#000",
    opacity: 0.2,
    rx: 1.751,
    ry: 1.746
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M153.365 25c.499 1.91.75 3.874.748 5.846 0 16.282-17.18 29.48-38.372 29.48-17.346-.01-32-8.848-36.741-20.976C82.521 52.84 98.025 63 116.625 63 137.818 63 155 49.801 155 33.52c-.005-2.917-.56-5.806-1.635-8.52z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.5,
    cy: 20.914,
    fill: "url(#prefix__f)",
    opacity: 0.8,
    rx: 79.281,
    ry: 20.841,
    transform: "translate(37 27)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M116.5 27C73.7 27 39 35.953 39 47h155c0-11.047-34.7-20-77.5-20zM116.5 68c42.8 0 77.5-8.954 77.5-20H39c0 11.046 34.7 20 77.5 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M116.5 68c42.8 0 77.5-8.954 77.5-20H39c0 11.046 34.7 20 77.5 20z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 11,
    x: 80,
    y: 42,
    fill: "#000",
    opacity: 0.05,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D8AF0",
    d: "M35.754 14.525c-.383-.168-.58-.595-.46-.995.01-.03.016-.06.018-.091.012-.182-.097-.35-.269-.414-.17-.063-.363-.006-.472.14-.018.025-.033.053-.045.081-.167.384-.595.581-.995.459-.03-.01-.06-.015-.092-.018-.182-.012-.35.098-.414.269-.063.17-.006.363.14.472.025.02.052.035.081.047.383.167.58.595.46.994-.01.03-.016.06-.018.09-.013.182.096.351.267.415.172.064.365.007.474-.14.019-.025.034-.053.045-.082.17-.38.598-.572.995-.448.03.009.06.015.092.018.182.011.35-.098.414-.269.063-.171.006-.363-.14-.473-.025-.022-.052-.04-.081-.055zM172.753 96.525c-.38-.172-.573-.598-.45-.995.01-.03.016-.06.018-.091.012-.182-.098-.35-.27-.414-.172-.063-.365-.006-.475.14-.018.025-.033.053-.045.081-.167.384-.596.581-.998.459-.03-.01-.061-.015-.092-.018-.183-.012-.352.098-.415.269-.064.17-.007.363.14.472.025.02.052.035.081.047.38.171.573.598.45.994-.01.03-.015.06-.018.09-.013.182.096.351.269.415.172.064.366.007.476-.14.018-.025.033-.053.045-.082.17-.38.6-.572.998-.448.03.009.061.015.092.018.183.011.352-.098.415-.269.064-.171.007-.363-.14-.473-.024-.022-.052-.04-.081-.055zM20.754 134.525c-.383-.168-.58-.595-.46-.995.01-.03.016-.06.018-.091.012-.182-.097-.35-.269-.414-.17-.063-.363-.006-.472.14-.018.025-.033.053-.045.081-.167.384-.595.581-.995.459-.03-.01-.06-.015-.092-.018-.182-.012-.35.098-.414.269-.063.17-.006.363.14.472.025.02.052.035.081.047.383.167.58.595.46.994-.01.03-.016.06-.018.09-.013.182.096.351.267.415.172.064.365.007.474-.14.019-.025.034-.053.045-.082.17-.38.598-.572.995-.448.03.009.06.015.092.018.182.011.35-.098.414-.269.063-.171.006-.363-.14-.473-.025-.022-.052-.04-.081-.055zM7.743 46.525c-.38-.172-.571-.598-.449-.995.01-.03.016-.06.018-.091.012-.182-.097-.35-.269-.414-.17-.063-.363-.006-.472.14-.018.025-.033.053-.045.081-.167.384-.595.581-.995.459-.03-.01-.06-.015-.092-.018-.182-.012-.35.098-.414.269-.063.17-.006.363.14.472.025.02.052.035.081.047.383.167.58.595.46.994-.01.03-.016.06-.018.09-.013.182.096.351.267.415.172.064.365.007.474-.14.019-.025.034-.053.045-.082.17-.38.598-.572.995-.448.03.009.06.015.092.018.182.011.35-.098.414-.269.063-.171.006-.363-.14-.473-.028-.023-.06-.041-.092-.055zM169.754 1.512c-.373-.17-.562-.592-.441-.986.01-.03.015-.06.018-.091.011-.18-.096-.347-.265-.41-.168-.062-.357-.006-.465.139-.017.025-.032.052-.044.08-.167.376-.587.567-.978.444-.03-.009-.06-.015-.09-.018-.197-.041-.393.068-.463.258s.007.402.183.5c.024.019.05.034.08.047.372.17.56.592.44.986-.01.029-.015.058-.018.089-.019.188.093.365.27.427.177.063.374-.006.475-.165.018-.026.033-.053.044-.083.168-.376.588-.567.978-.444.03.01.06.015.09.018.18.012.345-.097.407-.267s.006-.36-.138-.468c-.025-.023-.053-.041-.083-.056z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#47E6B1",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.059 0.236H3.059V4.958H2.059z",
    transform: "translate(27 68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.083 0.097L2.917 0.097 2.917 5.097 2.083 5.097z",
    transform: "translate(27 68) rotate(90 2.5 2.597)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#47E6B1",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.059 0.236H3.059V4.958H2.059z",
    transform: "translate(221 46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.083 0.097L2.917 0.097 2.917 5.097 2.083 5.097z",
    transform: "translate(221 46) rotate(90 2.5 2.597)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#47E6B1",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.059 0.236H3.059V4.958H2.059z",
    transform: "translate(194 122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.083 0.097L2.917 0.097 2.917 5.097 2.083 5.097z",
    transform: "translate(194 122) rotate(90 2.5 2.597)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 20.5,
    r: 1.5,
    fill: "#F55F44",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 2.5,
    r: 1.5,
    fill: "#F55F44",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 95.5,
    r: 1.5,
    fill: "#F55F44",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 40.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 54.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167,
    cy: 40.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167,
    cy: 54.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117,
    cy: 33.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 13.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106,
    cy: 20.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 23.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117,
    cy: 60.5,
    fill: "#000",
    opacity: 0.05,
    rx: 9,
    ry: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.24441eeeef283cddd05c302a742a9a2d.svg";
export { ForwardRef as ReactComponent };